<br>
<!--div class="form-row btntop2 col-sm-12 col-md-6" style="margin-top: 10px;min-width:900px;">
  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="form.reset();selectedyears=[];selectedinstitutions=[];clearReport()">Rensa</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Närvaro på medlemsnivå</p>
</div>
<hr /-->


<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" (click)="search()">Sök</button>
        <button class="btn border" (click)="form.reset();selectedyears=[];selectedinstitutions=[];clearReport()">Rensa</button>
        <button class="btn border" (click)="expanded = !expanded; expandedlabel = expandedlabel === 'Stäng grupper' ? 'Öppna grupper' : 'Stäng grupper'">{{ expandedlabel }}</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Närvaro på medlemsnivå</p>

    </div>
  </div>
</div>



<form [formGroup]="form" (keydown.enter)="search()" class="ms-4 me-4">
  <div class="col-md-5" style="min-width:500px;">
    <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Organisation
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <br>
      <div class="col-md-6" *ngIf="form.get('selectedFilter').value === '1'">
        <p-selectButton [options]="lodges" formControlName="lodges"></p-selectButton>
      </div>
      <div class="col-md-6" *ngIf="form.get('selectedFilter').value === '2'">
        <p-selectButton [options]="camps" formControlName="camps">
        </p-selectButton>
      </div>
      <div class="row">
        <div class="col-md-8">
     
          <label *ngIf="!access?.institution?.id">Välj institution</label>
        
            <p-select
  [options]="institutionslist"
  formControlName="institutionId"
  optionLabel="label"
  optionValue="value"
  [filter]="true"
  filterBy="label"
  appendTo="body"
  [showClear]="true"
  placeholder="Välj institution"
  (onChange)="setSingleInstitution($event)"
  class="w-full md:w-56">

  <ng-template pTemplate="selectedItem" let-selectedOption>
    <div class="flex items-center gap-2">
      <div>{{ selectedOption.label }}</div>
    </div>
  </ng-template>
</p-select>

        </div>
        <br>
        <div *ngIf="form.get('institutionId').value" class="col-md-12">
          <div class="col-md-6">
            <br>
            <b>Välj medlemmar</b><br>
            <mat-radio-group class="radio-group-spacing" aria-label="memberType" formControlName="memberType" (change)="radioSelection($event)">
              <mat-radio-button value="1">Alla medlemmar i institutionen</mat-radio-button>
              <mat-radio-button value="2">Välj ut medlemmar ur institutionen</mat-radio-button>
              <mat-radio-button value="3">Medlemmar utan närvaro</mat-radio-button>
            </mat-radio-group>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12">
              <div *ngIf="form.get('memberType').value === '2' && members.length === 0 && !viewselectedmembers && viewmembersearch" class="col-md-12">
                Sök och välj ut medlemmar ur institutionen
                <br><br>
                <form [formGroup]="memberform" (keydown.enter)="search()">
                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="memberId">
                        Id
                      </label>
                      <input type="text" class="form-control form-control-sm" id="memberId" formControlName="memberId">
                    </div>
                    <div class="form-group col-md-5">
                      <label for="givenName">
                        Förnamn
                      </label>
                      <input type="text" class="form-control form-control-sm" id="givenName" formControlName="givenName">
                    </div>
                    <div class="form-group col-md-5">
                      <label for="familyName">
                        Efternamn
                      </label>
                      <input type="text" class="form-control form-control-sm" id="familyName" formControlName="familyName">
                    </div>
                  </div>
                  <br>
                  <span>
                    <button class="btn border" (click)="searchMembers()">Sök</button>
                    <button class="btn border" style="margin-left:20px;" (click)="viewmembersearch=false;form.get('memberType').setValue(null)">Avbryt</button>
                  </span>
                  <br>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span>
        <button *ngIf="selectedmembersall.length > 0 && !viewselectedmembers" class="btn border" style="margin-left:10px;margin-bottom:5px;" (click)="addSelectedMembers();members=[]">Lägg till valda</button>
        <button class="btn border" *ngIf="members.length > 0" style="margin-left:10px;margin-bottom:5px;" (click)="members = [];viewmembersearch=false;form.get('memberType').setValue('');selectedmembersall = []">Avbryt</button>
      </span>
      <br><br>
      <div *ngIf="members.length > 0" class="col-md-12">
        <table class="table table-border">
          <tr>
            <th>Id</th>
            <th>Förnamn</th>
            <th>Efternamn</th>
            <th>Välj</th>
          </tr>
          <tr *ngFor="let m of members">
            <td>{{m.id}}</td>
            <td>{{m.givenName}}</td>
            <td>{{m.familyName}}</td>
            <td>
              <mat-checkbox id={{m.id}} [value]="m" (change)="addMember($event)"></mat-checkbox>
            </td>
          </tr>
        </table>
      </div>
      <div *ngIf="selectedmembersall.length > 0 && viewselectedmembers" class="col-md-12">
        <table class="table">
          <tr>
            <th>Id</th>
            <th>Förnamn</th>
            <th>Efternamn</th>
          </tr>
          <tr *ngFor="let m of selectedmembersall">
            <td>{{m.id}}</td>
            <td>{{m.givenName}}</td>
            <td>{{m.familyName}}</td>
          </tr>
        </table>
      </div>
      <br>
    </mat-expansion-panel>
  </div>
  <div class="col-md-5">
    <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Utmärkelse
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="signTypeId">
            Teckentyp
          </label>
          <select class="form-control form-control-sm" id="signTypeId" formControlName="signTypeId" (change)="getSignsBySignType($event, 'signlist')">
            <option></option>
            <option *ngFor="let st of signtypelist" [value]="st.id">{{st.name}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="signId">
            Utmärkelse
          </label>
          <select class="form-control form-control-sm" id="signId" formControlName="signId">
            <option></option>
            <option *ngFor="let s of signlist" [value]="s.id">{{s.name}} &nbsp; [{{s.abbreviation}}]</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="notSignTypeId">
            ICKE Teckentyp
          </label>
          <select class="form-control form-control-sm" id="notSignTypeId" formControlName="notSignTypeId" (change)="getSignsBySignType($event, 'notsignlist')">
            <option></option>
            <option *ngFor="let st of signtypelist" [value]="st.id">{{st.name}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="notSignId">
            ICKE Utmärkelse
          </label>
          <select class="form-control form-control-sm" id="notSignId" formControlName="notSignId">
            <option></option>
            <option *ngFor="let s of notsignlist" [value]="s.id">{{s.name}} &nbsp; [{{s.abbreviation}}]</option>
          </select>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
  <div class="col-md-5">
    <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Möten
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="form-group">
        <label for="meetingTypeId">
          Typ av möte
        </label>
        <select class="form-control form-control-sm" id="meetingTypeId" formControlName="meetingTypeId">
          <option></option>
          <option value="1">Ordinarie</option>
          <option value="2">Sommarmöte</option>
          <option value="3">Övrigt</option>
          <option value="4">Alla möten</option>
        </select>
      </div>
      <br>
      <div class="col-md-12">
        <b>Mötesinstitution</b><br>
        <mat-radio-group class="radio-group-spacing" aria-label="Mötesinstitution" formControlName="meetingInstitution"><br>
          <mat-radio-button value="1">Möten i egen institution</mat-radio-button>
          <mat-radio-button value="2">Möten i annan institution</mat-radio-button>
          <mat-radio-button value="3">Alla möten</mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-expansion-panel>
  </div>
  <div class="col-md-5">
    <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          År
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table>
        <tr>
          <td>      
            <p-multiselect #listbox appendTo="body" [options]="years" [filter]="false" optionLabel="year" [listStyle]="{'max-height':'150px'}" [style]="{'min-width':'110px', 'width':'110px'}" (onChange)="setYears($event)">
            </p-multiselect>
          </td>
          <td>
            <div *ngFor="let y of selectedyears" style="margin-left:40px;">{{y}}</div>
          </td>
          <td>
            <div *ngIf="selectedyears?.length > 0" class="col-md-1">
              <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Rensa valda år" (click)="selectedyears=[];clearYears()"><i class="fa fa-trash"></i></button>
            </div>
          </td>
        </tr>
      </table>
    </mat-expansion-panel>
  </div>
</form>
<br>
<div class="col-md-12" *ngIf="response?.length > 0">
  <p-menubar [model]="items">
    <div style="margin-top:5px;margin-right:10px;">
      Resultat: {{response?.length}}
    </div>
  </p-menubar>
  <table class="table table-border" style="width:1000px;">
    <tr>
      <th>Förnamn</th>
      <th>Efternamn</th>
      <ng-container *ngFor="let year of selectedyears">
        <th>{{ year}}</th>
        <th>Primärloge</th>
      </ng-container>
    </tr>
    <tr *ngFor="let r of response; index as i" class="border">
      <td>{{r?.givenName}}</td>
      <td>{{r?.familyName}}</td>
      <ng-container *ngFor="let y of r?.years">
        <td>{{y?.attendanceCount}}</td>
        <td>{{y?.primaryMemberLodge.shortName}}: {{y?.primaryMemberLodge.name}}</td>
      </ng-container>
    </tr>
  </table>
</div>
<hr>